import toastr from "src/components/Common/toastr";
import history from "./history";

export const handleNonAdminWorkspaceRoute = () => {
  toastr.error(
    "Only the organization owner / Admin can view the developer and settings sections"
  );
  history.replace("/dashboard");
};
